import { Navigate, Outlet } from "react-router-dom";

function ProtectedLayout({ allowedTypes }) {
  const token = localStorage.getItem("token");
  const userType = (localStorage.getItem("userType") || "").toLowerCase();

  if (!token || !allowedTypes.includes(userType)) {
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default ProtectedLayout;
